import script from "./DNickname.vue?vue&type=script&lang=ts&setup=true"
export * from "./DNickname.vue?vue&type=script&lang=ts&setup=true"

import "./DNickname.vue?vue&type=style&index=0&id=dc9c61de&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc9c61de"]])

export default __exports__